import { RolesService } from "@common/client"
import { currentUserKey, usersBaseKey, usersInfiniteBaseKey } from "./users"
import { makeAxiosMutation, makeNoArgsQuery } from "./utils"

export const rolesKey = ["roles"] as const

export const rolesQuery = makeNoArgsQuery({
  serviceCall: RolesService.listRoles,
  queryKey: rolesKey,
})

export const useCreateRoleMutation = makeAxiosMutation({
  serviceCall: RolesService.createRole,
  invalidates: () => [rolesKey],
})

export const useUpdateRoleMutation = makeAxiosMutation({
  serviceCall: RolesService.updateRole,
  invalidates: () => [
    rolesKey,
    currentUserKey,
    usersBaseKey,
    usersInfiniteBaseKey,
  ],
})

export const useResetRoleMutation = makeAxiosMutation({
  serviceCall: RolesService.resetRole,
  invalidates: () => [
    rolesKey,
    currentUserKey,
    usersBaseKey,
    usersInfiniteBaseKey,
  ],
})

export const useDeleteRoleMutation = makeAxiosMutation({
  serviceCall: RolesService.deleteRole,
  invalidates: () => [
    rolesKey,
    currentUserKey,
    usersBaseKey,
    usersInfiniteBaseKey,
  ],
})
